import lang from "@/views/modules/ApplicationEmails/language/en";
import breadcrumbs from "@/views/modules/ApplicationEmails/MenuList.vue";

export default {
    name: "app-email-edit",

    components: {
        breadcrumbs,
    },
    data() {
        return {
            appEmails: {},
            lang: [],
            record: null,
            fieldValue: null,
            process:false,
        }
    },
    mounted() {
        this.lang = lang;
        this.getEmail();
    },
    methods: {
        getEmail() {
            const self = this;
            self.process = true;
            window.currentAction = 'list';
                axios.get('api/modules/emails/getEmailSettingValue').then(function (response) {
                if (response.data != '' && response.data != 'null') {
                    self.process = false;
                    self.appEmails = response.data.smtp;
                    
                    self.appEmails.imap_server = response.data.imap.server_url;
                    self.appEmails.inbound_id = response.data.imap.id;
                    self.appEmails.imap_port = response.data.imap.port;
                    self.appEmails.imap_encryption = response.data.imap.mailbox_type;
                    self.appEmails.imap_user = response.data.imap.email_user;
                    self.appEmails.imap_password = response.data.imap.email_password;
                }
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
        saveEmail() {
            const errorMessages = document.getElementsByClassName('error-message');
            while (errorMessages.length > 0) {
                errorMessages[0].remove();
            }
            const self = this;
            self.loading = true;
            let fieldValue = document.getElementById('fieldValue').value;
            if (typeof (self.fieldValue) == 'undefined' || fieldValue == '') {
                axios.post('api/modules/applicationemails', self.emails).then(function (response) {
                    self.loading = false;
                    self.$notify({
                        title: self.$i18n.t('Success').toString(),
                        text: self.$i18n.t('Data saved correctly').toString(),
                        type: 'success'
                    });
                    self.$router.push('/modules/applicationemails');
                }).catch(function () {
                    self.loading = false;
                    let err = localStorage.getItem('Errors');
                    let err_msg = (JSON.parse(err));
                    let err_msg2 = err_msg.errors;
                    Object.keys(err_msg2).forEach((key) => {
                        let errorval = err_msg2[key];
                        const input = document.getElementById(key);
                        const errorDiv = document.createElement('span');
                        errorDiv.className = 'error-message error';
                        errorDiv.textContent = errorval;
                        input.insertAdjacentHTML('afterend', errorDiv.outerHTML);
                    });
                    localStorage.removeItem('Errors');
                });
            } else {
                axios.put(`api/modules/applicationemails/${fieldValue}`, self.emails).then(function (response) {
                    self.loading = false;
                    self.$notify({
                        title: self.$i18n.t('Success').toString(),
                        text: self.$i18n.t('Data update correctly').toString(),
                        type: 'success'
                    });
                    self.$router.push('/modules/applicationemails');
                }).catch(function () {
                    self.loading = false;
                    let err = localStorage.getItem('Errors');
                    let err_msg = (JSON.parse(err));
                    let err_msg2 = err_msg.errors;
                    Object.keys(err_msg2).forEach((key) => {
                        let errorval = err_msg2[key];
                        const input = document.getElementById(key);
                        const errorDiv = document.createElement('span');
                        errorDiv.className = 'error-message error';
                        errorDiv.textContent = errorval;
                        input.insertAdjacentHTML('afterend', errorDiv.outerHTML);
                    });
                    localStorage.removeItem('Errors');
                });
            }
        },
    },

}